module.exports = __webpack_public_path__ + "fonts/Adelle_Heavy.ce47f2a5.woff";